<template lang="pug">
 #deleteService
  .text-center
    b-icon(icon="x-circle" style="width: 80px; height: 80px; margin-bottom: 20px;" variant="danger")
    h2 ¿Estás Seguro?
    p Seguro que desea eliminar el servicio
      b  {{selectedService.name}}
    div(v-if="businesses.length")
      b IMPORTANTE:
      |  Esta acción es irreversible. Se eliminarán todos los datos del servicio
      |  (carpetas, documentos, estados de avance, etc...) para las siguientes empresas:  
      ul.mt-3
        li.text-left(v-for="business in businesses") {{business.name}}
  .modal-footer
    b-button(@click="hideModal", variant="outline-muted") Cancelar
    b-button(@click="confirmDelete" variant="danger") Eliminar
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: ["selectedService", "hideModal", "makeToast"],
  methods: {
    ...mapActions(['deleteService', 'listBusinessFromService']),
    async confirmDelete() {
      const response = await this.deleteService(this.selectedService.id);
      if (response.status === 200) {
        this.makeToast('success', response.data.message, "Servicio eliminado!");
        this.hideModal()
      } else {
        this.makeToast('danger', response.data, "Ocurrió un error!");
      }
    }
  },
  computed: {
    ...mapGetters(['businesses'])
  },
  async created () {
    await this.listBusinessFromService(this.selectedService.id)
  }
}
</script>

<style lang="scss" scoped>
#deleteService {
  .modal-footer {
    padding: 0;
  }  
}
</style>